import { useCallback, useState } from 'react';

export default (isOpenDefault = false) => {
    const [isOpen, setIsOpen] = useState(isOpenDefault);

    const onOpen = useCallback(() => setIsOpen(true), []);

    const onClose = useCallback(() => setIsOpen(false), []);

    const toggle = useCallback(toSet => {
        if (typeof toSet === 'undefined') {
            setIsOpen(state => !state);
        } else {
            setIsOpen(toSet);
        }
    }, []);

    return { isOpen, onOpen, onClose, toggle };
};
